import PaginationLoader from './PaginationLoader'
import fetchesNoteChildrenNotes from './dataSync/fetchesNoteChildrenNotes'
import fetchesChannelNotes from './dataSync/fetchesChannelNotes'

export const NoteChildrenLoader = fetchesNoteChildrenNotes()(PaginationLoader)
export const ChannelNotesLoader = fetchesChannelNotes()(PaginationLoader)
